module.exports = __webpack_public_path__ + "static/media/ebay.83ecaa76.jpg";